import React, {useState, useEffect } from 'react';
import SlideImage from './SlideImage';
import SlideVideo from './SlideVideo';
import SlideThumbnailRow from './SlideThumbnailRow';
import SlideThumbnailDotRow from './SlideThumbnailDotRow';
import SlideThumbnailCompactRow from './SlideThumbnailCompactRow';
import SlideThumbnailColumn from './SlideThumbnailColumn';



function Slideshow(props) {
  const [currentIdx, setCurrentIdx] = useState(0);
  const [zoomMode, setZoomMode] = useState(false);
  const [desktopMode, setDesktopMode] = useState(window.matchMedia(props.cfg.mediaClause).matches? false : true);

  //console.log("-> "+ props.cfg.mediaClause + " = " + desktopMode); 

  const nextSlide = () => {
    let idx;
    currentIdx === (props.images.length+props.videos.length-1) ?  idx = 0 : idx = currentIdx+1;
    setCurrentIdx(idx);
    //console.log("nextSlide() "+idx)
  }

  const prevSlide = () => {
    let idx;
    currentIdx === 0 ?  idx = (props.images.length+props.videos.length)-1 : idx = currentIdx-1;
    setCurrentIdx(idx);
    //console.log("prevSlide() "+idx)
  }

  function thumbnailClickHandler(e, idx) {
    //console.log("clicked idx "+idx);
    setCurrentIdx(idx);
  }
 
  function imageClickHandler(e, idx) {
    if (!desktopMode)
      return;
    //console.log("imageClickHandler() " + idx);
    setZoomMode(true);
    setCurrentIdx(idx);
  }
 
  function manageThumbnailColumn() {
    if ((props.cfg.sideThumbnail === "none") || (desktopMode === false)) {
      return null;
    }
    return (
      <SlideThumbnailColumn
        images={props.images}
        videos={props.videos}
        currentIdx={currentIdx}
        arrows={props.cfg.thumbArrows}
        prevSlide={prevSlide}
        nextSlide={nextSlide}
        clickHandler={thumbnailClickHandler}
        urlBase={props.urlBase}
      />
    );
  }  

  function manageThumbnailRow() {
    if  (desktopMode === true) {
      return null;
    } 
    if (props.cfg.rowThumbImg === true) {
      return (
        <SlideThumbnailRow
          images={props.images}
          videos={props.videos}
          currentIdx={currentIdx}
          prevSlide={prevSlide}
          nextSlide={nextSlide}
          clickHandler={thumbnailClickHandler}
          urlBase={props.urlBase}
        />
      );
    }    
    if (props.cfg.rowThumbDot === true) {
      return (
        <SlideThumbnailDotRow
          images={props.images}
          videos={props.videos}
          currentIdx={currentIdx}
          prevSlide={prevSlide}
          nextSlide={nextSlide}
          clickHandler={thumbnailClickHandler}
          urlBase={props.urlBase}
        />
      );
    }
    if (props.cfg.rowThumbCompact === true) {
      return (
        <SlideThumbnailCompactRow
          images={props.images}
          videos={props.videos}
          currentIdx={currentIdx}
          prevSlide={prevSlide}
          nextSlide={nextSlide}
          clickHandler={thumbnailClickHandler}
          urlBase={props.urlBase}
        />
      );
    }

  }

  function manageIcons() {
    return (
      <div className="ico-articolo">
        {props.new? <div className="ico-36x36 ico-news" title="Nuovo">&nbsp;</div> : ""}
        {props.inEvidence? <div className="ico-36x36 ico-evidenza" title="In Evidenza">&nbsp;</div> : ""}
      </div>
    );
 
  }

  function manageImages() {
    if (props.images == null) {
      return null;
    } 
    return props.images.map((img, i) =>
      desktopMode === true || currentIdx === i ? (
        // Without the `key`, React will fire a key warning
        <SlideImage
          key={"img_" + i}
          //filename={props.urlBase + img.DSNomeFile}
          //title={img.DSMetaTitle_It}
          //alt={img.DSMetaDescrizione_It}
          filename={img.url}
          title={img.alt}
          alt={img.alt}
          idx={i}
          active={currentIdx === i ? true : false}
          prevSlide={prevSlide}
          nextSlide={nextSlide}
          clickHandler={imageClickHandler}
          desktopMode={desktopMode}
          img={true}
          urlBase={props.urlBase}
        />
      ) : null
    );    
  } 

  function manageVideos() {
    if (props.videos == null) {
      return null;
    } 
    return props.videos.map((vid, i) =>
      desktopMode === true || currentIdx === (i+props.images.length) ? (
        // Without the `key`, React will fire a key warning
        <SlideVideo
          key={"vid_" + i}
          filename={vid.DSLink}
          title=""
          alt=""
          idx={props.images.length + i}
          active={(props.images.length > 0) && (currentIdx === (i+props.images.length)) ? true : false}
          prevSlide={prevSlide}
          nextSlide={nextSlide}
          clickHandler={imageClickHandler}
          desktopMode={desktopMode}
          img={false}
          urlBase={props.urlBase}
        />
      ) : null
    );    
  } 

  //console.log("DRAWING dm= " + desktopMode + ", zm = "+ zoomMode)

  function disableZoom() {
    //console.log("disableZoom()");
    setZoomMode(false);
  }
  function handleEscape(ev) {
    if (ev.key === 'Escape') {
      //console.log("handleEscape() " + ev.key);
      setZoomMode(false);
    }
  }

  function zoom() {
    if (desktopMode) {
      return (
        <div className="modal w3-animate-fading" style={{ display: "block" }}>
          <div>
            <div id="AW-modalHdr">
              <div
                className="ico-close-modal"
                title="Chiudi"
                onClick={disableZoom}
              >
                <img src="/images/chiusura_modal_on.svg" alt="close" />
              </div>
            </div>

            {currentIdx < props.images.length ? (
              <img
                className="modal-content"
                //src={props.urlBase + props.images[currentIdx].DSNomeFile}
                src={props.urlBase + props.images[currentIdx].url}
                alt=""
                title=""
              />
            ) : (
              <div className="modal-content">
                <iframe
                  title={"vid_" + props.idx}
                  width="100%"
                  height="100%"
                  src={
                    props.videos[currentIdx - props.images.length].DSLink +
                    "?html5=1&wmode=transparent&showinfo=0&rel=0"
                  }
                  allowFullScreen
                  frameBorder="0"
                />
              </div>
            )}

            {currentIdx > 0 ? (
              <div className="freccia_zoom_left" onClick={prevSlide}>
                <img
                  className="modal_arrow_left"
                  src="/images/Arrow_modal_left_on.svg"
                  alt="precedente"
                />
              </div>
            ) : null}
            {currentIdx < props.images.length + props.videos.length - 1 ? (
              <div className="freccia_zoom_right" onClick={nextSlide}>
                <img
                  className="modal_arrow_right"
                  src="/images/Arrow_modal_right_on.svg"
                  alt="successiva"
                />
              </div>
            ) : null}
          </div>
        </div>
      );
    }
  }


  // rileva il passaggio in modalità desktop/mobile (e viceversa), causando il
  // rendering della slideshow in modalità differente
  useEffect(() => {
    const onResize = () => {
      let mode = window.matchMedia(props.cfg.mediaClause).matches? false : true;
      //console.log("desktopMode = "+mode)
      if (mode !== desktopMode)
        setDesktopMode(mode);
    }

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("scroll", onResize);
  }, [desktopMode, props.cfg.mediaClause]);

  useEffect(() => {
    window.addEventListener('keydown', handleEscape);

    return () => {
      window.removeEventListener('keydown', handleEscape);
    };
  }, []);


  return (
    <>
      {manageThumbnailColumn()}
      <div className="slide_01">
        <div className="AW-slideshow" >
          {manageIcons()}
          {manageImages()}
          {manageVideos()}
        </div>
        <div className="clear"></div>
        {manageThumbnailRow()}
      </div>
      {zoomMode? zoom() : null}
    </>
  );
}


export default Slideshow;